module.exports = __webpack_public_path__ + "img/left-lightning3.0c20df84.png";